import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { MingoErrorsHandler } from './errors-handler.service';
import { BaseURL } from '../vay.config';
import { VayAntService } from './vay-ant.service';

@Injectable({
  providedIn: 'root',
})
export class VayService {
  private _data = new BehaviorSubject<any>({});
  data = this._data.asObservable();

  constructor(
    private http: HttpClient,
    private mingoErrorsHandler: MingoErrorsHandler,
    private vayAnt: VayAntService
  ) {}

  private fetchData = (uri: any) => (_params: any) => {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });

    return this.http
      .get(`${BaseURL}/api${uri}/`, {
        params,
      })
      .pipe(catchError((e: any) => this.mingoErrorsHandler.handleError(e)))
      .subscribe((data: any) => {
        this._data.next(data.data);
      });
  };
  private getFrontend = (uri: any) => (_params: any) => {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });

    return this.http
      .get(`${BaseURL}/api${uri}/frontend/`, {
        params,
      })
      .pipe(catchError((e: any) => this.mingoErrorsHandler.handleError(e))) as Observable<any>;
  };
  private getAll = (uri: any) => (_params: any) => {
    let params = new HttpParams();

    Object.keys(_params).map((key: any) => {
      params = params.append(key, _params[key] != null ? _params[key] : '');
    });

    return this.http
      .get(`${BaseURL}/api${uri}/`, {
        params,
      })
      .pipe(catchError((e: any) => this.mingoErrorsHandler.handleError(e))) as Observable<any>;
  };
  private getOne = (uri: any) => (id: any) => {
    return this.http
      .get(`${BaseURL}/api${uri}/${id}`)
      .pipe(catchError((e: any) => this.mingoErrorsHandler.handleError(e))) as Observable<any>;
  };
  private add = (uri: any) => (body: any) => {
    return this.http.post(`${BaseURL}/api${uri}/`, body).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };
  private edit = (uri: any) => (id: any, body: any) => {
    return this.http.put(`${BaseURL}/api${uri}/${id ? id : ''}`, body).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };
  private delete = (uri: any) => (id: any) => {
    return this.http.delete(`${BaseURL}/api${uri}/${id}/`).pipe(
      map((res: any) => {
        this.vayAnt.showMessage(res.message);
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };
  private active = (uri: any) => (id: any) => {
    return this.http.put(`${BaseURL}/api${uri}/${id}/active`, {}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };
  private read = (uri: any) => (id: any) => {
    return this.http.put(`${BaseURL}/api${uri}/${id}/read`, {}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };

  private showSymbol = (uri: any) => (id: any) => {
    return this.http.put(`${BaseURL}/api${uri}/${id}/show-symbol`, {}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((e: any) => this.mingoErrorsHandler.handleError(e))
    ) as Observable<any>;
  };

  VayVay(uri: any) {
    return {
      getAll: this.getAll(uri),
      getFrontend: this.getFrontend(uri),
      getOne: this.getOne(uri),
      add: this.add(uri),
      edit: this.edit(uri),
      delete: this.delete(uri),
      active: this.active(uri),
      showSymbol: this.showSymbol(uri),
      read: this.read(uri),
      fetchData: this.fetchData(uri),
      data: this.data,
    };
  }
}
